import React from 'react';
import clsx from 'clsx';

/**
 * White surface that holds a list table. The optional header carries the
 * list title, a result count and bulk actions; the table sits edge to edge.
 */
const TableCard = ({ title, count, extra, toolbar, children, className }) => (
  <div className={clsx('table-card', className)}>
    {title || extra ? (
      <div className="table-card__head">
        <div className="table-card__title">
          {title}
          {count !== undefined && count !== null ? (
            <span className="table-card__count">{count}</span>
          ) : null}
        </div>
        {extra ? <div className="table-card__extra">{extra}</div> : null}
      </div>
    ) : null}
    {toolbar ? <div className="table-card__toolbar">{toolbar}</div> : null}
    <div className="table-card__body">{children}</div>
  </div>
);

export default TableCard;
